import React from 'react';
import { Col, Row } from 'antd';
import Comment from './Comment';

interface CommentsListProps {
  dataSource: {
    comment: string
  }[];
}

const CommentsList = function ({ dataSource }: CommentsListProps) {
  return (
    <Row wrap justify="space-between" gutter={[24, 16]}>
      {dataSource.map(({ comment }, index) => (
      // eslint-disable-next-line react/no-array-index-key
        <Col flex={1} key={index} xs={24} xl={12}>
          <Comment comment={comment} />
        </Col>
      ))}
    </Row>
  );
};

export default CommentsList;
